import { BaseDto } from '../base.dto';
import { IsDefined, IsInt, IsNumber } from 'class-validator';

export class BankingCashUpMultiCurrencyDto extends BaseDto {
  @IsDefined()
  @IsInt()
  bankingCashUpId: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  reconCash: number;
}
